export default __webpack_public_path__ + "static/media/14381.ac-society-committee.photo.0dc5b186.jpg";